// @flow
import React from 'react'
import './styles.scss'
// https://reactjsexample.com/a-very-simple-echarts-wrapper-for-react/
import ReactEcharts from 'echarts-for-react'
import echarts from 'echarts'
import { Waypoint } from 'react-waypoint'

const valuesForType = (type, data) => {
  const filteredData = data.filter(t => {
    return t.type === type
  })
  let valuesArr = filteredData.map(year => year.count)
  // console.log(valuesArr)
  return valuesArr
}

export class ChartTelephones extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
      isMobile: window.innerWidth < 650,
      isTablet: window.innerWidth < 800,
      hasEntered: false,
      chartOptions: {}
    }
    this.onEnter = this.onEnter.bind(this)
  }

  onEnter() {
    if (!this.state.hasEntered) {
      this.setState({
        hasEntered: true,
        chartOptions: this.getOption()
      })
    }
  }

  setHighlightYear(targetSeries) {
    if (this.props.userGroups) {
      // console.log('### USERGROUP ###')
      // console.log(this.props.userGroups)

      this.props.userGroups.length > 0 &&
        this.props.userGroups.map(el => {
          let highlightDate = el.highlight.toISOString().substr(0, 10) // convert 'Tue Jan 01 1980 01:00:00 GMT+0100 (Mitteleuropäische Normalzeit)' TO '1980-01-01'
          // console.log('highlightDate: ', highlightDate)
          // console.log('highlight_y: ', el.highlight_y)
          // console.log('from: ', el.from)
          // console.log('to: ', el.to)

          // console.log('targetSeries: ' + targetSeries)
          let filteredArray = this.props.data
            .filter(function(el) {
              return el.type === targetSeries
            })
            .map(function(el) {
              return el
            })
          // console.log('### FILTERED ARRAY ###')
          // console.log(filteredArray)

          // console.log('### DATA ###')
          // console.log(this.props.data)

          for (let i = 0; i < filteredArray.length; i++) {
            // console.log(filteredArray[i].date + '==' + highlightDate)
            if (filteredArray[i].date === highlightDate) {
              // console.log('matched!')
              this.newHighlightIndex = i
              this.newHighlight_y = el.highlight_y
              break
            }
          }
        })
    } else {
      this.newHighlightIndex = 1
    }
    // console.log('----- newHighlightIndex: ' + this.newHighlightIndex + '---------')
    return [this.newHighlightIndex, this.newHighlight_y]
  }

  // Chart Options
  // https://ecomfe.github.io/echarts-doc/public/en/option.html#title
  getOption = () => ({
    title: {
      text: '',
      subtext: ''
    },
    tooltip: {
      position: 'left',
      show: true,
      formatter: function(params, ticket, callback) {
        // console.log('#### params ####', params)
        // get date
        let currDate = params[0].axisValue.match(/\d+/g)
        let currYear = currDate[0]
        let currMonth = currDate[1]
        let currDay = currDate[2]
        currDate = currDay + '.' + currMonth + '.' + currYear
        let title = '<div class="tip-title">' + currDate + '</div>'
        let tooltipContent = title + '<hr class="under" />'
        let valuesAreNull = true
        for (let i = 0; i < params.length; i++) {
          if (params[i].value > -0.00000000001) {
            let dotColor = params[i].color
            tooltipContent += '<div class="row">'
            tooltipContent += '<span class="dot" style="background-color:'
            tooltipContent += dotColor
            tooltipContent += '">&nbsp;</span>'
            tooltipContent += params[i].seriesName + ': '
            tooltipContent +=
              '<span class="weighted">' +
              (Math.round(params[i].value * 10) / 10)
                .toString()
                .replace(/\./g, ',') + //round to 1 decimal place, replace dot with comma
              '%</span></div>'
            valuesAreNull = false
          }
        }
        // callback(console.log('scrubbed to: ', params[0].dataIndex))
        if (!valuesAreNull) {
          return tooltipContent
        }
      },
      textStyle: {
        color: '#333'
      },
      backgroundColor: '#f3f3f3',
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
        label: {
          show: true,
          formatter: function(params) {
            let yearOnly = params.value.substring(0, 4)
            return yearOnly
          },
          backgroundColor: '#aaa',
          textStyle: {
            fontSize: '16',
            fontFamily:
              'TamediaChart,Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif',
            color: '#fff'
          }
        }
      }
    },
    legend: {
      data: [
        {
          name: 'SIM-Karten',
          icon: 'circle'
        },
        {
          name: 'Smartphones',
          icon: 'circle'
        }
      ],
      show: false
    },
    grid: [
      {
        top: this.state.isMobile ? '5%' : '5%',
        left: 4,
        right: 12,
        bottom: 11,
        containLabel: true
      }
    ],
    xAxis: {
      type: 'category',
      boundaryGap: false,
      z: -2,
      data: [...new Set(this.props.data.map(year => year.date))],
      min: this.state.isMobile ? '1978-12-31' : '1978-12-31',
      axisTick: {
        interval: this.state.isMobile ? 3 : 'auto'
      },
      axisLabel: {
        interval: this.state.isMobile ? 3 : 'auto',
        formatter: function(value) {
          let yearOnly = value.substring(0, 4)
          return yearOnly
        },
        textStyle: {
          color: '#fff',
          fontSize: 10
        }
      },
      axisLine: {
        lineStyle: {
          color: ['#bbb']
        }
      }
    },
    yAxis: {
      type: 'value',
      z: -2,
      axisTick: {
        show: false
      },
      splitLine: {
        lineStyle: {
          // Dark and light colors will be used in turns
          color: ['#666']
        }
      },
      axisLine: {
        show: false
      },
      axisLabel: {
        formatter: function(value, index) {
          return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'")
        },
        textStyle: {
          color: '#fff'
        }
      }
    },
    series: [
      {
        name: 'SIM-Karten',
        type: 'line',
        showSymbol: false,
        connectNulls: true,
        color: this.props.lineColors['Mobilfunkkunden'], // this has to be defined in main.js!!
        data: valuesForType('Mobilfunkkunden', this.props.data),
        z: -1,
        animationDelay: 500,
        markPoint: {
          animationDelay: 750,
          data: [
            {
              name: 'Natel D',
              value: 'Natel D',
              coord: this.state.isMobile ? [-9999, -9999] : [15, 2.7],
              label: {
                formatter: this.state.isMobile
                  ? ['{b|1993}', 'Start Natel D-Netz', 'mit Vorwahl 079'].join(
                      '\n'
                    )
                  : ['{b|1993}', 'Start Natel D-Netz', 'mit Vorwahl 079'].join(
                      '\n'
                    ),
                color: '#fff',
                align: 'right',
                rich: {
                  b: {
                    color: '#fff',
                    fontSize: 14,
                    fontWeight: 'bold',

                    fontSize: this.state.isMobile ? 12 : 14
                  }
                },
                fontSize: this.state.isMobile ? 12 : 14,
                position: this.state.isMobile ? [15, 15] : [10, -45]
              },
              symbol: 'pin', // 'pin', 'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'arrow', 'none'
              symbolSize: 25,
              symbolOffset: [0, -5],
              animationDelay: 1000
            },
            {
              name: 'SMS',
              value: 'SMS',
              coord: [17, 6.3],
              label: {
                formatter: this.state.isMobile
                  ? ['{b|1995}', 'SMS wird', 'lanciert'].join('\n')
                  : ['{b|1995}', 'SMS wird', 'lanciert'].join('\n'),
                color: '#fff',
                align: this.state.isMobile ? 'right' : 'left',
                rich: {
                  b: {
                    color: '#fff',
                    fontSize: 14,
                    fontWeight: 'bold',

                    fontSize: this.state.isMobile ? 12 : 14
                  }
                },
                fontSize: this.state.isMobile ? 12 : 14,
                position: this.state.isMobile ? [-5, -7] : [0, -45]
              },
              symbol: 'pin', // 'pin', 'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'arrow', 'none'
              symbolSize: 25,
              symbolOffset: [0, -5],
              animationDelay: 1250
            },
            {
              name: 'Nokia 3210',
              value: 'Nokia 3210',
              coord: this.setHighlightYear('Mobilfunkkunden'),
              label: {
                formatter: this.state.isMobile
                  ? ['{b|1999}', 'Nokia 3210 wird', 'zum Publikumshit'].join(
                      '\n'
                    )
                  : ['{b|1999}', 'Nokia 3210 wird', 'zum Publikumshit'].join(
                      '\n'
                    ),
                color: '#fff',
                align: this.state.isMobile ? 'right' : 'left',
                rich: {
                  b: {
                    color: '#fff',
                    fontSize: 14,
                    fontWeight: 'bold',

                    fontSize: this.state.isMobile ? 12 : 14
                  }
                },
                fontSize: this.state.isMobile ? 12 : 14,
                position: this.state.isMobile ? [-5, 5] : [22, 5]
              },
              symbol: 'pin', // 'pin', 'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'arrow', 'none'
              symbolSize: 25,
              symbolOffset: [0, -5],
              animationDelay: 1500
            },
            {
              name: 'Kamerahandy',
              value: 'Kamerahandy',
              coord: [24, 78.4],
              label: {
                formatter: this.state.isMobile
                  ? ['{b|2002}', 'Handy-Kamera', 'wird Standard'].join('\n')
                  : ['{b|2002}', 'Handy-Kamera wird Standard'].join('\n'),
                color: '#fff',
                align: this.state.isMobile ? 'right' : 'left',
                rich: {
                  b: {
                    color: '#fff',
                    fontWeight: 'bold',
                    fontSize: this.state.isMobile ? 12 : 14
                  }
                },
                fontSize: this.state.isMobile ? 12 : 14,
                position: this.state.isMobile ? [-7, 3] : [5, 30]
              },
              symbol: 'pin', // 'pin', 'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'arrow', 'none'
              symbolSize: 25,
              animationDelay: 1750
            },
            {
              name: 'Mobilfunkkunden',
              value: 'Mobilfunkkunden',
              coord: this.state.isMobile ? [15, 120] : [23, 115],
              symbol: 'rect',
              symbolSize: 0.01,
              label: {
                position: this.state.isMobile ? [0, 0] : [0, 50],
                formatter: ['{b|SIM-Karten*}'].join('\n'),
                rich: {
                  b: {
                    fontSize: 14,
                    color: '#fff',
                    padding: [3, 4, 5, 4],
                    backgroundColor: this.props.lineColors['Mobilfunkkunden']
                  }
                }
              }
            }
          ]
        }
      },
      {
        name: 'Smartphones',
        type: 'line',
        showSymbol: false,
        connectNulls: true,
        color: this.props.lineColors['Smartphones'], // this has to be defined in main.js!!
        animationDelay: 1000,
        z: -1,
        data: valuesForType('Smartphones', this.props.data),
        markPoint: {
          show: false,
          animationDelay: 1250,
          data: [
            {
              name: 'Smartphones',
              value: 'Smartphones',
              coord: this.state.isMobile ? [24, 55] : [29, 48],
              symbol: 'rect',
              symbolSize: 0.01,
              label: {
                position: this.state.isMobile ? [0, -20] : [0, 0],
                formatter: ['{b|Smartphones**}'].join('\n'),
                rich: {
                  b: {
                    fontSize: 14,
                    color: '#fff',
                    padding: [3, 4, 5, 4],
                    backgroundColor: this.props.lineColors['Smartphones']
                  }
                }
              }
            },
            {
              name: 'iPhone',
              value: 'iPhone',
              coord: [29, 6],
              label: {
                formatter: this.state.isMobile
                  ? ['{b|2007}', 'Apple lanciert', 'das iPhone'].join('\n')
                  : ['{b|2007}', 'Apple lanciert', 'das iPhone'].join('\n'),
                color: '#fff',
                align: this.state.isMobile ? 'left' : 'right',
                rich: {
                  b: {
                    color: '#fff',
                    fontSize: 14,
                    fontWeight: 'bold',
                    fontSize: this.state.isMobile ? 12 : 14
                  }
                },
                fontSize: this.state.isMobile ? 12 : 14,
                position: this.state.isMobile ? [18, 3] : [-5, -20]
              },
              symbol: 'pin', // 'pin', 'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'arrow', 'none'
              symbolSize: 25,
              symbolOffset: [0, -5],
              animationDelay: 1500
            }
          ]
        }
      }
    ]
  })
  render() {
    // register theme object
    // theme object format example: https://github.com/apache/incubator-echarts/blob/master/theme/dark.js
    echarts.registerTheme('ta_theme', {
      backgroundColor: 'transparent',
      textStyle: {
        fontSize: '16',
        fontFamily:
          'TamediaChart,Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif',
        color: '#fff'
      },
      title: {
        textStyle: {
          color: '#fff',
          fontSize: '22'
        },
        subtextStyle: {
          color: '#fff',
          fontSize: '18'
        }
      },
      legend: {
        left: 'left',
        orient: 'vertical',
        itemGap: 7,
        padding: [0, 0, 0, 10],
        itemWidth: 10,
        textStyle: {
          fontSize: '16'
        },
        show: false
      },
      label: {
        show: false
      },
      smooth: true
    })

    return (
      <div className='echart'>
        <Waypoint
          onEnter={this.onEnter}
          onLeave={this.onLeave}
          topOffset='100'
        />
        <h3>{this.props.title}</h3>
        <h5>{this.props.subtitle}</h5>
        <ReactEcharts
          option={this.state.chartOptions}
          opts={{ renderer: 'canvas' }}
          notMerge
          lazyUpdate
          theme={'ta_theme'}
          style={{ height: this.state.isMobile ? '28em' : '30em' }}
        />
        <div className='note'>
          * Grund für das Übersteigen von 100%: Inhaber von mehreren SIM-Karten
          <br />
          ** 2005–2011 US-Zahlen, da Werte für die Schweiz fehlen
        </div>
        <div className='source'>
          Quellen: Bakom, Comparis, Pew Research Center
        </div>
      </div>
    )
  }
}
